import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type { BlockType } from '@unifyapps/defs/types/block';
import type { StackBlockStateType, StackComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import Stack from './Stack';

class StackBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  get type(): 'Stack' {
    return 'Stack';
  }

  get initialStateGetter() {
    return (block: BlockType<StackComponentType>) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as StackBlockStateType;
  }

  getComponent() {
    return Stack;
  }
}

export default StackBlockStateDefinition;
